// extracted by mini-css-extract-plugin
module.exports = {"root":"_2f9a2c","selected":"_a35cdd"};